/**
 * This module performs a critical self-check on startup to ensure that the
 * frontend application is configured with the correct backend API URLs.
 * It prevents the app from accidentally communicating with outdated local servers.
 */

const apiUrl = process.env.REACT_APP_API_URL;

console.log('--- Environment Variable Check ---');
console.log(`REACT_APP_API_URL: ${apiUrl}`);

if (process.env.NODE_ENV === 'development' && (!apiUrl || !apiUrl.includes('tarotreadingcard.online'))) {
  const errorMessage = `
    FATAL: Invalid API configuration for local development.
    Please create a '.env.local' file in the 'tarot-diary-app/client' directory with the following content:
    REACT_APP_API_URL=https://diary.tarotreadingcard.online
  `;
  alert(errorMessage);
  throw new Error(errorMessage);
}
console.log('--- Environment variables are configured correctly. ---');